module.exports = __webpack_public_path__ + "img/avatar_bg.0d29fd4c.svg";